function exhaustiveSwitchError(value, property) {
  const debugValue = property && value && typeof value === "object" && property in value ? value[property] : value;
  throw new Error(`Unknown switch case ${debugValue}`);
}
function asMessage(message) {
  if (Array.isArray(message)) return message;
  if (typeof message === "string") return [{ type: "text", text: message }];
  return [message];
}
export {
  asMessage,
  exhaustiveSwitchError
};
//# sourceMappingURL=utils.mjs.map
